// extracted by mini-css-extract-plugin
module.exports = {"tip":"Services_tip__KHOBT"};